import react,{Component} from 'react';
import {
  DKLabel,
  DKButton,
  DKSpinner,
  DKIcon,
  showAlert,
  DKTooltipWrapper,
} from "deskera-ui-library";
import RouteManager, { PAGE_ROUTES } from '../../managers/RouteManager';
import { DefaultReportConfig, FEDRAL_INFO, INReportConfig, SGReportConfig, STATE_FORM_ROUTES, USEmployeeReportConfig, USReportConfig, MYReportConfig } from './ReportsConstants';
import { CONSTANTS, COUNTRY_CODE } from '../../constants/Constant';
import TenantManager from '../../managers/TenantManager';
import report from '../../assets/icons/report/Reports.svg';
import cpf from '../../assets/icons/report/CPF.svg';
import IRAS from '../../assets/icons/report/IRAS.svg';
import Forms from '../../assets/icons/report/Forms.svg';
import { TENANT, TenantService } from '../../managers/TenantManagerService';
import { isUSCompliance, showAccessDeniedAlert } from '../../managers/common/CommonUtil';
import ic_info_warning from "../../assets/icons/ic_info_gray.svg";
import Utility from '../../utility/Utility';
import Table from '../../services/table';
import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";
import DefaultForm from "./compliance/US/DefaultForm";
import ic_info_gray from "../../assets/icons/ic_info_gray.svg";
import INTaxService from '../../services/compliance/IN/IntaxSerivce';
import i18next from 'i18next';
import PermissionUtils, { ACTION, MODULE } from '../user-permissions/PermissionUtils';

export default class ReportsList extends Component {
  reportList = [];
  countryState = "";
  constructor(props) {
    super(props);
    this.getReportList();
    const { tenant } = TenantManager.getPeopleTenantData();
    this.tenantData = !Utility.isEmpty(tenant) ? tenant : "";
    this.countryCode =
      this.tenantData && this.tenantData.countryCode
        ? this.tenantData.countryCode
        : "";
    this.address =
      this.tenantData && this.tenantData.address ? this.tenantData.address : "";
    this.countryState =
      !Utility.isEmpty(this.address) && !Utility.isEmpty(this.address.state)
        ? this.address.state
        : "";
    this.state = {
      isStateReportEnabled: false,
      tenantData:
        this.tenantData && this.tenantData.tenant ? this.tenantData.tenant : {},
      countryCode: this.countryCode,
      countryState: this.countryState,
    };
  }
  getReportList() {
    const { tenant } = TenantManager.getPeopleTenantData();
    const countryCode = tenant && tenant.countryCode ? tenant.countryCode : "";
    switch (countryCode) {
      case COUNTRY_CODE.US:
        this.reportList = TenantService.get(TENANT.IS_ADMIN)
          ? USReportConfig
          : USEmployeeReportConfig;
        break;
      case COUNTRY_CODE.INDIA:
        this.getTaxDetail()
        this.reportList = INReportConfig;
        break;
      case COUNTRY_CODE.SG:
        this.reportList = SGReportConfig;
        break;
      case COUNTRY_CODE.MY:
        this.reportList = MYReportConfig;
        break;
      default:
        this.reportList = DefaultReportConfig;
    }
  }

  getTaxDetail() {
    INTaxService.getTaxDetail()
      .then(res => {
        if (res['compliance']) {
          this.reportList?.column2[0]?.reports?.forEach(col => {
            if (!res['compliance'].esiApplicable && col.id == "esiTaxReport") {
              col['isRestrictToNav'] = {
                message: `${col.name} ${i18next.t("REPORT_APPLICABLE_MESSAGE")}`,
                navUrl: PAGE_ROUTES.IN_TAX_DETAILS
              }
            } else if (!res['compliance'].epfApplicable && col.id == "epfTaxReport") {
              col['isRestrictToNav'] = {
                message: `${col.name} ${i18next.t("REPORT_APPLICABLE_MESSAGE")}`,
                navUrl:PAGE_ROUTES.IN_TAX_DETAILS
              }
            } else if (!col.id == "professionalTaxReport") {
              col['isRestrictToNav'] = {
                message: `${col.name} ${i18next.t("REPORT_APPLICABLE_MESSAGE")}`,
                navUrl:PAGE_ROUTES.IN_TAX_DETAILS
              }
            } else {
              col['isRestrictToNav'] = false
            }
          })
          this.setState({
            ...this.state
          })
        }
      })
  }
  getStateForms(country, state) {
    if (!Utility.isEmpty(state) && COUNTRY_CODE.US === country) {
      Table.getStateFormsAndFields(country, state).then(
        (response) => {
          if (response?.forms?.length > 0) {
            const stateForms = response.forms;
            const sections = this.prepareStateFormData(stateForms);
            this.reportList["column4"] = sections;
            this.setState({
              isStateReportEnabled: true,
            });
          }
        },
        (err) => {
          showAlert("Error!", "Server error occurred.");
        }
      );
    }
  }

  componentDidMount() {
    RouteManager.setPresenter(this);
    const { tenant } = TenantManager.getPeopleTenantData();
    const countryCode = tenant && tenant.countryCode ? tenant.countryCode : "";
    this.getStateForms(this.countryCode, this.countryState);
    switch (countryCode) {
      case COUNTRY_CODE.INDIA:
        if (!TenantService.get(TENANT.IS_ADMIN) && !PermissionUtils.hasAccess(MODULE.REPORTS,[ACTION.VIEW])) {
          this.navigateTo("", false, {});
        }
        break;
    }
  }

  getIcon(name) {
    switch (name) {
      case "Forms.svg":
        return Forms;
      case "Reports.svg":
        return report;
      case "CPF.svg":
        return cpf;
      case "IRAS.svg":
        return IRAS;
      default:
        return Forms;
    }
  }

  getTitle(col) {
    return (
      <div className=" pt-l pl-l" style={{ backgroundColor: "#e2e3e2" }}>
        {col[0] && <DKLabel className="fw-m fs-xl" text={col[0].title} />}
        <div className="d-flex justify-content-end">
          <img className="ic-xl " src={this.getIcon(col[0].icon)} />
        </div>
      </div>
    );
  }

  getList(col) {
    if (col && col[0] && col[0].reports) {
      let report = col[0].reports;
      let name = report.map((res) => {
        return (
          <>
            {!res.hidden && (
              <div
                onClick={() => {
                  if(res.isRestrictToNav) {
                    showAlert(i18next.t("INFO"),res.isRestrictToNav.message,[
                      { title: i18next.t("GO_TO_SETTING"), className: "bg-app text-white mr-l", onClick: () => this.navigateTo(res.isRestrictToNav.navUrl) },
                      { title: i18next.t("CANCEL"), className: "bg-gray1  border-m" }
                  ])
                  } else {
                    this.navigateTo(res.url, res.isDefaultRouteConfigured, res);
                  }
                }}
                className=""
              >
                <div className="d-flex align-items-center data-grid-header">
                  <DKLabel
                    className={`m-0 cursor-hand ${res.isToolTip ? "p-v-l pl-l" : "p-l"}`}
                    text={res.name}
                  />
                  {res.isToolTip && (
                    <div
                      className=""
                      style={{ marginTop: "4px", marginLeft: "4px" }}
                    >
                      <DKTooltipWrapper
                        content={res.tooltipDescription}
                        tooltipClassName="warning-tooltip-prop"
                      >
                        <DKIcon
                          src={ic_info_gray}
                          className="ic-s mr-r cursor-hand"
                        />
                      </DKTooltipWrapper>
                    </div>
                  )}
                </div>
              </div>
            )}
          </>
        );
      });
      return name;
    } else {
      return "";
    }
  }

  navigateTo(url, isDefaultRouteConfigured, formObject) {
    if (isDefaultRouteConfigured) {
      this.props.history.push({
        pathname: PAGE_ROUTES.REPORT.US.FORM,
        state: { details: formObject },
      });
    } else if(formObject.isRouteToCommonReports) {
        this.props.history.push({
          pathname: PAGE_ROUTES.REPORT.SG.FORM,
          state: { module: formObject.module, source: "report-list" },
        });
    } else {
        if (formObject.id === "payrollSummaryReport" || formObject.id === "payrollLiabilityReport") {
            if (PermissionUtils.hasAccess(MODULE.SALARY, [ACTION.VIEW, ACTION.EDIT])) {
                RouteManager.navigateToPage(url);
            } else {
                showAccessDeniedAlert();
            }
        } else {
            RouteManager.navigateToPage(url);
        }
    }
  }

  getReport() {
    return (
      <div className="parent-width d-flex mt-l">
        {this.reportList.column1 && (
          <div
            className="parent-height mr-xl"
            style={{
              width: "33%",
              height: "fit-content",
            }}
          >
            <div className="card-shadow border-radius-s parent-height">
                {this.getTitle(this.reportList.column1)}
                <div className="border-radius-s" style={{ backgroundColor: "#f5f5f5" }}>
                    {this.getList(this.reportList.column1)}
                </div>
            </div>
            {this.reportList.automationReport && (
              <div
                style={{
                  width: "100%",
                  height: "fit-content",
                }}
                className="card-shadow border-radius-s mt-l parent-height"
              >
                {this.getTitle(this.reportList.automationReport)}
                <div
                  className="border-radius-s"
                  style={{ backgroundColor: "#f5f5f5" }}
                >
                  {this.getList(this.reportList.automationReport)}
                </div>
              </div>
            )}
            {this.reportList.statutoryReports && (
              <div
                style={{
                  width: "100%",
                  height: "fit-content",
                }}
                className="card-shadow border-radius-s mt-l parent-height"
              >
                {this.getTitle(this.reportList.statutoryReports)}
                <div
                  className="border-radius-s"
                  style={{ backgroundColor: "#f5f5f5" }}
                >
                  {this.getList(this.reportList.statutoryReports)}
                </div>
              </div>
            )}
          </div>
        )}
        {this.reportList.column2 && (
          <div
            style={{
              width: "33%",
              height: "fit-content",
            }}
            className="card-shadow mr-xl border-radius-s parent-height"
          >
            {this.getTitle(this.reportList.column2)}
            <div
              className="border-radius-s"
              style={{ backgroundColor: "#f5f5f5" }}
            >
              {this.getList(this.reportList.column2)}
            </div>
          </div>
        )}
        {this.reportList.column3 && (
          <div
            style={{
              width: "33%",
              height: "fit-content",
            }}
            className="parent-height"
          >
            <div className="card-shadow border-radius-s parent-height">
              {this.getTitle(this.reportList.column3)}
              <div
                className="border-radius-s"
                style={{ backgroundColor: "#f5f5f5" }}
              >
                {this.getList(this.reportList.column3)}
              </div>
            </div>
            {this.reportList.column4 && (
              <div
                style={{
                  width: "100%",
                  height: "fit-content",
                }}
                className="card-shadow border-radius-s mt-l parent-height"
              >
                {this.getTitle(this.reportList.column4)}
                <div
                  className="border-radius-s"
                  style={{ backgroundColor: "#f5f5f5" }}
                >
                  {this.getList(this.reportList.column4)}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  getUSComplianceReportInfo() {
    return (
      <div className="row p-v-m p-h-m mt-s bg-deskera-secondary">
        <DKIcon className="mr-s" src={ic_info_warning} />
        {FEDRAL_INFO}
      </div>
    );
  }

  prepareStateFormData(formJson) {
    let section = [];
    let forms = {
      title: "State Forms (Beta)",
      icon: "Forms.svg",
      reports: [],
    };
    formJson.forEach((form) => {
      let item = {};
      for (const [key, value] of Object.entries(form)) {
        item[key] = value;
      }
      item["url"] = STATE_FORM_ROUTES[form.id] && STATE_FORM_ROUTES[form.id].URL
        ? STATE_FORM_ROUTES[form.id].URL
        : STATE_FORM_ROUTES[CONSTANTS.REPORT_NO_ROUTE]>URL;
      item["isDefaultRouteConfigured"] = true;
      forms["reports"].push(item);
    });
    section.push(forms);
    return section;
  }

  render() {
    return (
      <div className="parent-width">
        <DKLabel text="Reports" className="fw-m fs-l" />
        {isUSCompliance() && this.getUSComplianceReportInfo()}
        {this.getReport()}
      </div>
    );
  }
}